import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { DokumentStavka } from './dokument-stavka';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-dokument-stavka-modal-update',
  templateUrl: './dokument-stavka-modal-update.component.html'
})
export class DokumentStavkaModalUpdateComponent
 extends BaseModalUpdateComponent<DokumentStavka>{

  constructor(
    protected modalContainerService: ModalContainerService<DokumentStavka>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }


}
